import { render, staticRenderFns } from "./PendingPaymentTooltip.vue?vue&type=template&id=0ff01954&scoped=true"
import script from "./PendingPaymentTooltip.vue?vue&type=script&lang=js"
export * from "./PendingPaymentTooltip.vue?vue&type=script&lang=js"
import style0 from "./PendingPaymentTooltip.vue?vue&type=style&index=0&id=0ff01954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff01954",
  null
  
)

export default component.exports